import { HttpClient } from '@angular/common/http';
import { identifierModuleUrl } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { url } from 'src/environments/environment.prod';
import { Post } from './post';

@Injectable({
  providedIn: 'root'
})

export class PostService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getAllPostsByDate(date: string): Observable<Post[]> {
    return this.httpClient.post<Post[]>(url + '/post', { 'date': date });
  }

  changePrior(id: string, date: string, up: boolean): Observable<Post[]> {
    return this.httpClient.post<Post[]>(url + '/post/change', { 'id': id, 'date': date, 'up': up });
  }

  create(concreteQuality: string, concreteQuantity: string, customer: string, customerCode: string, fromLocation: string, toLocation: string, phoneNumber: string, username: string, date: string, hour: string, licensePlateNumbers: string[], comment: string): Observable<Boolean> {
    return this.httpClient.post<Boolean>(url + '/post/create', { 'concreteQuality': concreteQuality, 'concreteQuantity': concreteQuantity, 'customer': customer, 'customerCode': customerCode, 'fromLocation': fromLocation, 'toLocation': toLocation, 'phoneNumber': phoneNumber, 'username': username, 'date': date, 'hour': hour, 'licensePlateNumbers': licensePlateNumbers, 'comment': comment });
  }

  modify(id: string, concreteQuality: string, concreteQuantity: string, customer: string, customerCode: string, fromLocation: string, toLocation: string, phoneNumber: string, username: string, date: string, hour: string, licensePlateNumbers: string[], comment: string, priority: number): Observable<Boolean> {
    return this.httpClient.post<Boolean>(url + '/post/modify', { 'postId': id, 'concreteQuality': concreteQuality, 'concreteQuantity': concreteQuantity, 'customer': customer, 'customerCode': customerCode, 'fromLocation': fromLocation, 'toLocation': toLocation, 'phoneNumber': phoneNumber, 'userName': username, 'date': date, 'hour': hour, 'priority': priority, 'licensePlateNumbers': licensePlateNumbers, 'comment': comment });
  }

  delete(id: string): Observable<Post[]> {
    return this.httpClient.post<Post[]>(url + '/post/delete', id);
  }

  getLicensePlates(): Observable<string[]> {
    return this.httpClient.get<string[]>(url + '/license');
  }

  getPost(id: string): Observable<Post> {
    return this.httpClient.post<Post>(url + '/post/get', id);
  }

  solvePost(id: string): Observable<Post[]> {
    return this.httpClient.post<Post[]>(url + '/post/solve/' + id, null);
  }

}